import { HStack } from "@/components/Elements/Layouts/Stack";
import { RealtorState } from "@/store/realtorState";
import { Box } from "@mui/material";
import { useRecoilState } from "recoil";
import styled from "styled-components";

const HeaderText = styled.div`
  font-size: 10px;
  @media screen and (min-width: 240px) {
    font-size: 14px;
  }
  @media screen and (min-width: 360px) {
    font-size: 18px;
  }
  @media screen and (min-width: 480px) {
    font-size: 22px;
  }
`;

export const Header: React.FC = () => {
  const [realtor] = useRecoilState(RealtorState);
  
  // エラー排他処理
  if(realtor.display == undefined)return <></>
  if(!realtor.display.title)return <></>

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 20,
        height: 60,
        fontWeight: "bold",
      }}
      color="#313131"
    >
      <HStack alignItems="center" spacing={1}>
          {realtor.header.logo ? (
            <img src={realtor.header.logo} height={30} />
          ) : (
            <></>
          )}
          {realtor.header.text ? (
            <HeaderText>{realtor.header.text}</HeaderText>
          ) : (
            <></>
          )}
        </HStack>
    </Box>
  );
};
